export default __webpack_public_path__ + "static/media/saucy.ff8e1010.jpeg";